const styles = {
  container: 'hidden lg:flex',

  button: 'bg-[#FFF] hover:!opacity-20 cursor-pointer !text-base w-full',
};

export default styles;
